<section class="simulation grid-container grid-container--section no-gutter-mobile" data-overload-controller="AdhesionPegaseCtrl">
    <app-stepper-component [currentStepId]="'etude_dossier'"></app-stepper-component>
    <div>
        <form cand-scroll-error="" method="POST" novalidate="" data-ng-submit="adhesion.validate($event)" enctype="multipart/form-data">
            <fieldset class="simulation__step" data-ng-form="adhesionForm" name="adhesionForm">
                <legend style="display: none">
                    {{ 'differeddecisionintroduction.title' | i18n }}
                </legend>
                <div data-ui-view="adhesionSteps">
                    <section class="document-selection">
                        <div class="simulation__group" data-ng-if="documentSelection.isBasicLayout()">
                            <div cand-scroll-error="" data-ui-view="documentStep" autoscroll="false">
                                <section class="differed-decision-introduction">
                                    <div class="differed-decision-introduction__content">
                                        <div class="differed-decision-introduction__content-image"></div>
                                        <p class="differed-decision-introduction__content-title">
                                            {{ 'differeddecisionintroduction.title' | i18n }}
                                        </p>
                                        <!-- ngIf: differeddecisionintroduction.differeddecisiondescription is 'contractual' --><span
                                            data-ng-if="differeddecisionintroduction.differeddecisiondescription=== 'contractual'"
                                            class="differed-decision-introduction__content-description"
                                        >
                                            {{ 'differeddecisionintroduction.description.contractual' | i18n }}
                                        </span>
                                        <!-- end ngIf: differeddecisionintroduction.differeddecisiondescription is 'contractual' -->
                                        <!-- ngIf: differeddecisionintroduction.differeddecisiondescription is 'additional' -->
                                        <!-- ngIf: differeddecisionintroduction.differeddecisiondescription is 'mixte' -->
                                        <div class="differed-decision-introduction__content__link">
                                            {{ 'differeddecisionintroduction.seemore' | i18n }}
                                            <a data-tag-commander="" [appTagCommander]="'tagCo.documentselection.differeddecisionintroduction.faq.button'" (click)="toggleFaq()">
                                                <strong id="faqLink">{{ 'differeddecisionintroduction.seemorelink' | i18n }}</strong>
                                            </a>
                                        </div>
                                    </div>

                                    <div class="simulation__buttons simulation__buttons--light">
                                        <button type="button" class="button button--primary button--next float-right centered" routerLink="/souscription/document-medicale/document-list">
                                            {{ 'differeddecisionintroduction.buttons.continue' | i18n }}
                                        </button>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </section>
                </div>
            </fieldset>
        </form>
    </div>
</section>

<app-modal-faqs [visibility]="showFaqModal" (visibilityChange)="toggleFaq()"></app-modal-faqs>
<app-steps-adhesion-modal [currentStepId]="'etude_dossier'"> </app-steps-adhesion-modal>
